// 9fbef606107a605d69c0edbcd8029e5d
import { reducer as reduxFormReducer } from 'redux-form';
import LabelReducer from '@tcp/core/src/reduxStore/reducers/labels';
import SEODataReducer from '@tcp/core/src/reduxStore/reducers/seoData';
import LayoutReducer from '@tcp/core/src/reduxStore/reducers/layout';
import SubNavigationReducer from '@tcp/core/src/reduxStore/reducers/subNavigation';
import ApiConfigReducer from '@tcp/core/src/reduxStore/reducers/apiConfig';
import SessionConfigReducer from '@tcp/core/src/reduxStore/reducers/sessionConfig';
import ModulesReducer from '@tcp/core/src/reduxStore/reducers/modules';
import { createFilteredReducer } from '@tcp/core/src/utils/redux.util';
import QuickViewReducer from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.reducer';
import CartPage from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.reducer';
import NonCachedCartPage from '@tcp/core/src/components/features/CnC/CartItemTile/container/NonCachedCart.reducer';
import CheckoutReducer from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.reducer';
import OverlayModalReducer from '@tcp/core/src/components/features/account/OverlayModal/container/OverlayModal.reducer';
import ProductListingReducer from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.reducer';
import MyProfileReducer from '@tcp/core/src/components/features/account/MyProfile/container/MyProfile.reducer';
import DeviceInfoReducer from '@tcp/core/src/reduxStore/reducers/deviceInfo';
import ProductDetailReducer from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.reducer';
import StyliticsProductTabListReducer from '@tcp/core/src/components/common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.reducer';
import PickupModalReducer from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.reducer';
import OutfitDetailReducer from '@tcp/core/src/components/features/browse/OutfitDetails/container/OutfitDetails.reducer';
import RecommendationsReducer from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.reducer';
import DyRecommendationsReducer from '@tcp/core/src/components/common/molecules/DyRecommendations/container/DyRecommendations.reducer';
import SearchBarReducer from '@tcp/core/src/components/common/molecules/SearchBar/SearchBar.reducer';
import StoreLocatorReducer from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.reducer';
import SearchPageReducer from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.reducer';
import StoreDetailReducer from '@tcp/core/src/components/features/storeLocator/StoreDetail/container/StoreDetail.reducer';
import NavigateXHRReducer from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.reducer';
// Removed StoreListReducer and MyPreferenceSubscriptionReducer due to dynamic injection of reducer.
import BundleProductReducer from '@tcp/core/src/components/features/browse/BundleProduct/container/BundleProduct.reducer';
import AnalyticsReducer from '@tcp/core/src/analytics/Analytics.reducer';
import AbTestReducer from '@tcp/core/src/components/common/molecules/abTest/abtest.reducer';
import LastUpdatedReducer from '@tcp/core/src/reduxStore/reducers/lastUpdated';
import SinglePageCheckoutReducer from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.reducer';
import mergeAccountReducer from '@tcp/core/src/components/features/account/CustomerHelp/organisms/MergeAccounts/container/MergeAccounts.reducer';
import bundleReducer from '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.reducer';
import promotionsReducer from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.reducer';
import CategoryListingPageReducer from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.reducer';
import HorizontalCategoryReducer from '@tcp/core/src/components/features/browse/HorizontalCategory/container/HorizontalCategory.reducer';
import CustomerHelpReducer from '@tcp/core/src/components/features/account/CustomerHelp/container/CustomerHelp.reducer';
import FavoriteReducer from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.reducer';
import BossUnavailableReducer from '@tcp/core/src/components/features/CnC/CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.reducer';
import PromoCombinationReducer from '@tcp/core/src/reduxStore/reducers/promoCombination';
import AdyenPaymentReducer from '@tcp/core/src/components/common/organisms/AdyenPayment/container/AdyenPayment.reducer';
import CustomerLoyaltyReducer from '@tcp/core/src/reduxStore/reducers/customerLoyalty.reducer';

import {
  APICONFIG_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
  HEADER_REDUCER_KEY,
  FOOTER_REDUCER_KEY,
  LABEL_REDUCER_KEY,
  SEO_DATA_REDUCER_KEY,
  LAYOUT_REDUCER_KEY,
  LOADER_REDUCER_KEY,
  PLCC_OFFER_REDUCER_KEY,
  MODULES_REDUCER_KEY,
  CARTPAGE_REDUCER_KEY,
  NON_CACHED_CART_REDUCER_KEY,
  OVERLAY_MODAL_REDUCER_KEY,
  NAVIGATION_REDUCER_KEY,
  PRODUCT_LISTING_REDUCER_KEY,
  MY_PROFILE_REDUCER_KEY,
  USER_REDUCER_KEY,
  CHECKOUT_REDUCER_KEY,
  DEVICE_INFO_REDUCER_KEY,
  PRODUCT_DETAIL_REDUCER_KEY,
  OUTFIT_DETAILS_REDUCER_KEY,
  STYLITICS_PRODUCT_TAB_LIST_REDUCER_KEY,
  PICKUP_MODAL_REDUCER_KEY,
  RECOMMENDATIONS_REDUCER_KEY,
  DY_RECOMMENDATIONS_REDUCER_KEY,
  SEARCH_REDUCER_KEY,
  STORE_LOCATOR_REDUCER_KEY,
  SLP_PAGE_REDUCER_KEY,
  STORE_DETAIL_REDUCER_KEY,
  QUICK_VIEW_REDUCER_KEY,
  // STORE_LIST_REDUCER_KEY,
  // MY_PREFERENCE_REDUCER_KEY,
  BUNDLEPRODUCT_REDUCER_KEY,
  ANALYTICS_DATA_KEY,
  SUB_NAVIGATION_REDUCER_KEY,
  SITEMAP_REDUCER_KEY,
  AB_TEST_STORE_PATTERN,
  NAVIGATE_XHR,
  LAST_UPDATED_REDUCER_KEY,
  SINGLE_PAGE_REDUCER_KEY,
  MERGE_ACCOUNT_REDUCER_KEY,
  BUNDLE_TRACKER_REDUCER_KEY,
  PROMOTIONS_REDUCER_KEY,
  CUSTOMER_HELP_REDUCER_KEY,
  FAVORITES_REDUCER_KEY,
  DYNAMIC_SIZE_CHART_REDUCER_KEY,
  COUNTRY_SELECTOR_REDUCER_KEY,
  PROMO_COMBINATION_REDUCER_KEY,
  ADYEN_REDUCER_KEY,
  SHOP_BY_LOOK_STYLITICS_REDUCER_KEY,
  CUSTOMER_LOYALTY_REDUCER_KEY,
  LOYALTY_PLACE_REWARDS_REDUCER,
} from '@tcp/core/src/constants/reducer.constants';
import { TRACK_PAGE_VIEW, UPDATE_PAGE_DATA } from '@tcp/core/src/analytics';
import LoaderReducer from '@tcp/core/src/components/common/molecules/Loader/container/Loader.reducer';
import HeaderReducer from '@tcp/core/src/components/common/organisms/Header/container/Header.reducer';
import FooterReducer from '@tcp/core/src/components/common/organisms/Footer/container/Footer.reducer';
import NavigationReducer from '@tcp/core/src/components/features/content/Navigation/container/Navigation.reducer';
import UserReducer from '@tcp/core/src/components/features/account/User/container/User.reducer';
import InYourBagReducer from '@tcp/core/src/components/features/browse/InYourBag/container/InYourBag.reducer';
import DynamicSizeChartReducer from '@tcp/core/src/components/common/molecules/DynamicSizeChart/container/DynamicSizeChart.reducer';
import AddPickUpPersonReducer from '@tcp/core/src/components/features/account/OrderDetails/organism/AddPickupPerson/container/AddPickUpPersonForm.reducer';
import CountrySelectorReducer from '@tcp/web/src/components/features/content/HeaderNew/molecules/CountrySelector/container/CountrySelector.reducer.js';
import ShopByLookStyliticsReducer from '@tcp/core/src/components/common/molecules/ShopByLookStylitics/container/ShopByLookStylitics.reducer';
import LoyaltyPlaceRewardsReducer from '@tcp/core/src/components/features/account/PlaceRewards/container/PlaceRewards.reducer';
import SiteMapReducer from '../../components/features/content/SiteMap/container/SiteMap.reducer';
import PlccOfferModalReducer from '../../components/common/molecules/PlccOfferModal/container/PlccOfferModal.reducer';

const filteredAppConfigReducer = createFilteredReducer(ApiConfigReducer, APICONFIG_REDUCER_KEY);
// TODO: filteredSessionConfigReducer should be used, but issue with immutable map to be corrected
// const filteredSessionConfigReducer = createFilteredReducer(
//   SessionConfigReducer,
//   SESSIONCONFIG_REDUCER_KEY
// );

const filteredStyliticsProductTabListReducer = createFilteredReducer(
  StyliticsProductTabListReducer,
  STYLITICS_PRODUCT_TAB_LIST_REDUCER_KEY
);

/**
 * TODO: This reducer is fragile. We should handle page
 * name changes in a cleaner way.
 *
 * @see RouteTracker.js
 */
function pageNameReducer(state = {}, action) {
  switch (action.type) {
    case TRACK_PAGE_VIEW: {
      const { props } = action.payload || {};
      const { pageData = {} } = (props && props.initialProps && props.initialProps.pageProps) || {};
      return { ...state, ...pageData };
    }
    case UPDATE_PAGE_DATA: {
      return action.payload;
    }
    default:
      return state;
  }
}

export default {
  pageData: pageNameReducer,
  [APICONFIG_REDUCER_KEY]: filteredAppConfigReducer,
  [SESSIONCONFIG_REDUCER_KEY]: SessionConfigReducer,
  [NAVIGATE_XHR]: NavigateXHRReducer,
  [HEADER_REDUCER_KEY]: HeaderReducer,
  [FOOTER_REDUCER_KEY]: FooterReducer,
  [LABEL_REDUCER_KEY]: LabelReducer,
  [SEO_DATA_REDUCER_KEY]: SEODataReducer,
  [LAYOUT_REDUCER_KEY]: LayoutReducer,
  [MODULES_REDUCER_KEY]: ModulesReducer,
  [LOADER_REDUCER_KEY]: LoaderReducer,
  [SEARCH_REDUCER_KEY]: SearchBarReducer,
  form: reduxFormReducer,
  [PLCC_OFFER_REDUCER_KEY]: PlccOfferModalReducer,
  [CARTPAGE_REDUCER_KEY]: CartPage,
  [NON_CACHED_CART_REDUCER_KEY]: NonCachedCartPage,
  [CHECKOUT_REDUCER_KEY]: CheckoutReducer,
  [OVERLAY_MODAL_REDUCER_KEY]: OverlayModalReducer,
  [NAVIGATION_REDUCER_KEY]: NavigationReducer,
  [PRODUCT_LISTING_REDUCER_KEY]: ProductListingReducer,
  [MY_PROFILE_REDUCER_KEY]: MyProfileReducer,
  [USER_REDUCER_KEY]: UserReducer,
  [DEVICE_INFO_REDUCER_KEY]: DeviceInfoReducer,
  [PRODUCT_DETAIL_REDUCER_KEY]: ProductDetailReducer,
  [OUTFIT_DETAILS_REDUCER_KEY]: OutfitDetailReducer,
  [STYLITICS_PRODUCT_TAB_LIST_REDUCER_KEY]: filteredStyliticsProductTabListReducer,
  [PICKUP_MODAL_REDUCER_KEY]: PickupModalReducer,
  [RECOMMENDATIONS_REDUCER_KEY]: RecommendationsReducer,
  [DY_RECOMMENDATIONS_REDUCER_KEY]: DyRecommendationsReducer,
  [STORE_LOCATOR_REDUCER_KEY]: StoreLocatorReducer,
  [SLP_PAGE_REDUCER_KEY]: SearchPageReducer,
  [STORE_DETAIL_REDUCER_KEY]: StoreDetailReducer,
  [QUICK_VIEW_REDUCER_KEY]: QuickViewReducer,
  [BUNDLEPRODUCT_REDUCER_KEY]: BundleProductReducer,
  [ANALYTICS_DATA_KEY]: AnalyticsReducer,
  [SUB_NAVIGATION_REDUCER_KEY]: SubNavigationReducer,
  [SITEMAP_REDUCER_KEY]: SiteMapReducer,
  [AB_TEST_STORE_PATTERN]: AbTestReducer,
  [LAST_UPDATED_REDUCER_KEY]: LastUpdatedReducer,
  [SINGLE_PAGE_REDUCER_KEY]: SinglePageCheckoutReducer,
  [MERGE_ACCOUNT_REDUCER_KEY]: mergeAccountReducer,
  [BUNDLE_TRACKER_REDUCER_KEY]: bundleReducer,
  [PROMOTIONS_REDUCER_KEY]: promotionsReducer,
  CategoryListingPage: CategoryListingPageReducer,
  HorizontalCategory: HorizontalCategoryReducer,
  InYourBag: InYourBagReducer,
  bossUnavailable: BossUnavailableReducer,
  AddPickUpPerson: AddPickUpPersonReducer,
  [CUSTOMER_HELP_REDUCER_KEY]: CustomerHelpReducer,
  [FAVORITES_REDUCER_KEY]: FavoriteReducer,
  [DYNAMIC_SIZE_CHART_REDUCER_KEY]: DynamicSizeChartReducer,
  [COUNTRY_SELECTOR_REDUCER_KEY]: CountrySelectorReducer,
  [PROMO_COMBINATION_REDUCER_KEY]: PromoCombinationReducer,
  [ADYEN_REDUCER_KEY]: AdyenPaymentReducer,
  [SHOP_BY_LOOK_STYLITICS_REDUCER_KEY]: ShopByLookStyliticsReducer,
  [CUSTOMER_LOYALTY_REDUCER_KEY]: CustomerLoyaltyReducer,
  [LOYALTY_PLACE_REWARDS_REDUCER]: LoyaltyPlaceRewardsReducer,
};
